export default __webpack_public_path__ + "static/media/LENS_CULINARIS_GDM_6.ca75f0b5.jpg";